module.exports = __webpack_public_path__ + "static/media/BrainHealth.28420bb3.jpg";